import UtilArray from "@/utils/UtilArray.mjs";
import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import UtilSequence from "@/utils/UtilSequence.mjs";
import useColaboradorStore from "@stores/ColaboradorStore.js";

export default {

    async criaDespesa(despesaValores = {}){

        const colaboradorStore = useColaboradorStore();
        const colaboradorID = colaboradorStore?.colaborador?.id || "";

        let ordemDePagamentoDespesa;

        try{

            //==================================================================//
            //============= SE TIVER ANEXOS FAZ UPLOAD DOS ANEXOS ==============//
            //==================================================================//

            let anexosURLs = [];

            if(UtilArray.isNotEmpty(despesaValores?.anexos)){

                let anexosValores = {
                    bucket: "simjob-bucket-deltaducon",
                    colaborador: colaboradorID,
                    arquivos: despesaValores?.anexos,
                }

                let anexos = await ERP.colaboradorUploadAnexos(anexosValores);
                if(anexos.status != 200){
                    throw anexos;
                }

                console.log(anexos);

                anexosURLs = anexos.data || [];

            }

            //==================================================================//
            //====================== PREPARO DOS VALORES =======================//
            //==================================================================//

            despesaValores = {
                despesa: despesaValores?.despesa || "",
                dataCriacao: despesaValores?.dataCriacao || "",
                dataDaDespesa: despesaValores?.dataDaDespesa || "",
                valor: despesaValores?.valor || 0,
                veiculoTipo: despesaValores?.veiculoTipo || "Nenhum",
                veiculoPlaca: despesaValores?.veiculoPlaca || "",
                veiculoKMInicial: despesaValores?.veiculoKMInicial || 0,
                veiculoKMFinal: despesaValores?.veiculoKMFinal || 0,
                observacao: despesaValores?.observacao ?? "",
                anexos: anexosURLs ?? [],
            };

            //==================================================================//
            //================= CRIA DESPESA ORDEM DE PAGAMENTO ================//
            //==================================================================//

            ordemDePagamentoDespesa = await ERP.postOne(Schema.ORDEM_DE_PAGAMENTO_DESPESAS, despesaValores);
            if(ordemDePagamentoDespesa.status != 200){
                throw ordemDePagamentoDespesa;
            }

            console.log(ordemDePagamentoDespesa);

        }catch(e){

            console.log(e);
            return ordemDePagamentoDespesa;

        }

        return ordemDePagamentoDespesa;

    },

    async criaDespesas(despesasValores = []){

        const colaboradorStore = useColaboradorStore();
        const colaboradorID = colaboradorStore?.colaborador?.id || "";

        let ordemDePagamentoDespesas = {
            data: [],
            status: 200
        };

        try{

            //==================================================================//
            //================ CRIA DESPESAS ORDEM DE PAGAMENTO ================//
            //==================================================================//

             ordemDePagamentoDespesas.data = await UtilSequence.each({
                list: despesasValores,
                callback: async (despesaValores)=>{

                    //==================================================================//
                    //============= SE TIVER ANEXOS FAZ UPLOAD DOS ANEXOS ==============//
                    //==================================================================//

                    let anexosURLs = [];

                    if(UtilArray.isNotEmpty(despesaValores?.anexos)){

                        let anexosValores = {
                            bucket: "simjob-bucket-deltaducon",
                            colaborador: colaboradorID,
                            arquivos: despesaValores?.anexos,
                        }

                        let anexos = await ERP.colaboradorUploadAnexos(anexosValores);
                        if(anexos.status != 200){
                            throw anexos;
                        }

                        console.log(anexos);

                        anexosURLs = anexos.data || [];

                    }

                    //==================================================================//
                    //====================== PREPARO DOS VALORES =======================//
                    //==================================================================//

                    despesaValores = {
                        despesa: despesaValores?.despesa || "",
                        dataCriacao: despesaValores?.dataCriacao || "",
                        dataDaDespesa: despesaValores?.dataDaDespesa || "",
                        valor: despesaValores?.valor || 0,
                        veiculoTipo: despesaValores?.veiculoTipo || "Nenhum",
                        veiculoPlaca: despesaValores?.veiculoPlaca || "",
                        veiculoKMInicial: despesaValores?.veiculoKMInicial || 0,
                        veiculoKMFinal: despesaValores?.veiculoKMFinal || 0,
                        observacao: despesaValores?.observacao ?? "",
                        anexos: anexosURLs ?? [],
                    };
                
                    //==================================================================//
                    //================= CRIA DESPESA ORDEM DE PAGAMENTO ================//
                    //==================================================================//

                    let ordemDePagamentoDespesa = await ERP.postOne(Schema.ORDEM_DE_PAGAMENTO_DESPESAS, despesaValores);
                    if(ordemDePagamentoDespesa.status != 200){
                        throw ordemDePagamentoDespesa;
                    }

                    console.log(ordemDePagamentoDespesa);

                    return ordemDePagamentoDespesa.data;

                }
            });

        }catch(e){

            console.log(e);
            return ordemDePagamentoDespesas;

        }

        return ordemDePagamentoDespesas;

    },

    async alteraDespesa(despesaValores = {}){

        const colaboradorStore = useColaboradorStore();
        const colaboradorID = colaboradorStore?.colaborador?.id || "";

        let ordemDePagamentoDespesa;

        try{

            //==================================================================//
            //============= SE TIVER ANEXOS FAZ UPLOAD DOS ANEXOS ==============//
            //==================================================================//

            if(UtilArray.isNotEmpty(despesaValores?.anexos)){

                let anexosValores = {
                    bucket: "simjob-bucket-deltaducon",
                    colaborador: colaboradorID,
                    arquivos: despesaValores?.anexos,
                }

                let anexos = await ERP.colaboradorUploadAnexos(anexosValores);
                if(anexos.status != 200){
                    throw anexos;
                }

                console.log(anexos);

                despesaValores.anexos = anexos.data || [];

            }

            //==================================================================//
            //================ ALTERA DESPESA ORDEM DE PAGAMENTO ===============//
            //==================================================================//

            ordemDePagamentoDespesa = await ERP.patchOne(Schema.ORDEM_DE_PAGAMENTO_DESPESAS, despesaValores);
            if(ordemDePagamentoDespesa.status != 200){
                throw ordemDePagamentoDespesa;
            }

            console.log(ordemDePagamentoDespesa);

        }catch(e){

            console.log(e);
            return ordemDePagamentoDespesa;

        }

        return ordemDePagamentoDespesa;

    },

    async alteraDespesas(despesasValores = []){

        const colaboradorStore = useColaboradorStore();
        const colaboradorID = colaboradorStore?.colaborador?.id || "";

        let ordemDePagamentoDespesas = {
            data: [],
            status: 200
        };

        try{

            //==================================================================//
            //================ CRIA DESPESAS ORDEM DE PAGAMENTO ================//
            //==================================================================//

             ordemDePagamentoDespesas.data = await UtilSequence.each({
                list: despesasValores,
                callback: async (despesaValores)=>{

                    //==================================================================//
                    //============= SE TIVER ANEXOS FAZ UPLOAD DOS ANEXOS ==============//
                    //==================================================================//

                    if(UtilArray.isNotEmpty(despesaValores?.anexos)){

                        let anexosValores = {
                            bucket: "simjob-bucket-deltaducon",
                            colaborador: colaboradorID,
                            arquivos: despesaValores?.anexos,
                        }

                        let anexos = await ERP.colaboradorUploadAnexos(anexosValores);
                        if(anexos.status != 200){
                            throw anexos;
                        }

                        console.log(anexos);

                        despesaValores.anexos = anexos.data || [];

                    }

                    let ordemDePagamentoDespesa = await ERP.patchOne(Schema.ORDEM_DE_PAGAMENTO_DESPESAS, despesaValores);
                    if(ordemDePagamentoDespesa.status != 200){
                        throw ordemDePagamentoDespesa;
                    }

                    console.log(ordemDePagamentoDespesa);

                    return ordemDePagamentoDespesa.data;

                }
            });

        }catch(e){

            console.log(e);
            return ordemDePagamentoDespesas;

        }

        return ordemDePagamentoDespesas;

    },

}